import type {PullRequestState} from '../types'

/**
 * Determines if a pull request is in an open state.
 * Open states are: OPEN, DRAFT, and QUEUED.
 * Closed, merged, and archived PRs are considered non-open.
 */
export function isPullRequestOpenState(state: PullRequestState): boolean {
  return state === 'OPEN' || state === 'DRAFT' || state === 'QUEUED'
}
